import { theme as defaultTheme, Theme } from "@hurleymc/components"

const colors = {
  hurleyGme: "#8F5300", // was #A86200 (4.21:1 on #F1F1F1) — now 5.46:1, WCAG AA compliant
}

const theme: Partial<Theme> = {
  ...defaultTheme,
  colors: {
    ...defaultTheme.colors,
    default: colors.hurleyGme,
    primary: colors.hurleyGme,
  },
}

export default theme
